"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('trips', {
            url: '/trips',
            template: require('../views/trips-list.html'),
            controller: 'TripsListController',
            controllerAs: 'trips_list',
            resolve: {
                auth: ['auth', function (auth) {
                        return auth.getIdentity();
                    }]
            }
        })
            .state('trips_edit', {
            url: '/trips/edit/:id?',
            params: { id: null },
            template: require('../views/trips-edit.html'),
            controller: 'TripsEditController',
            controllerAs: 'trips_edit',
            resolve: {
                trip: ['$stateParams', '_trip', function ($stateParams, _trip) {
                        if ($stateParams.id) {
                            return _trip.get($stateParams.id)
                                .then(function (item) {
                                return item[0];
                            }, function (err) {
                                console.log(err);
                            });
                        }
                        else {
                            return {};
                        }
                    }],
                auth: ['auth', function (auth) {
                        return auth.getIdentity();
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/config/routes.js
// module id = 602
// module chunks = 0